<template>
    <el-dialog
        :visible.sync="show"
        width="40%"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        destroy-on-close
        custom-class="file-waiting-modal"
    >
        <div class="file-waiting-modal--body">
            <div v-if="isLoading" style="width: 100%;">
                <div v-loading="isLoading" :element-loading-text="loadingText"></div>
            </div>
            <div v-if="!isLoading" class="waiting-modal-text">
                <div v-if="hasError">
                    <p>Une erreur est survenue lors de la génération du fichier d'export des moteurs.</p>
                    <p>Veuillez réessayer, si le problème persiste, contactez un administrateur</p>
                </div>
                <div v-else>
                    <p>Le fichier d'export des moteurs a été généré.</p>
                    <p>Le téléchargement va débuter automatiquement.</p>
                </div>
            </div>
        </div>
        <span slot="footer">
            <el-button v-if="!isLoading" type="primary" @click="close">Close</el-button>
        </span>
    </el-dialog>
</template>

<script>
import WaitingMixin from 'fundation-app-vuejs/src/components/partials/waitingMixin';
export default {
    mixins: [WaitingMixin],
    components: {

    },

    props: {
        loadingText: {
            type: String,
            default: 'Génération en cours du fichier d\'export des moteurs...',
        },
    },

    data (){
        return {
            show: false,
        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        open (){
            this.isLoading = true;
            this.show = true;
        },
        close (){
            this.show = false;
        },
        displayError (){
            this.isLoading = false;
            this.hasError = true;
        }
    },
};
</script>

<style lang="scss">

@import '../../../assets/styles/variables';

.waiting-modal-text{
    color: $--color-primary;
    text-align: center;
    font-weight: 600;
}
.file-waiting-modal{
    min-height: 250px;
}
.file-waiting-modal--body{
    min-height: 200px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/WaitingModal/index.vue